import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from "@components/ui/sidebar";
import { Link } from "react-router-dom";
import type { UserVM } from "@shared-kernel/application/ports/shared/shared-repository";
import { useSession } from "@user-management-context/primary/hooks/use-session";
import logoLight from "../../../../assets/img/logo/new-logo-light.svg";
import logoDark from "../../../../assets/img/logo/new-logo-dark.svg";
import smallLogo from "../../../../assets/img/logo/new-logo-small.svg";
import { ADMIN_URLS, ROLE_BASED_URLS } from "src/routes";

interface Props {
  user: UserVM;
  state: "expanded" | "collapsed";
}

export function NavHeader({ user, state }: Props) {
  const isCollapsed = state === "collapsed";
  const { activeRole } = useSession();
  const nonAdminRole = activeRole && !user.isAdmin ? activeRole : null;
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton size="lg" asChild className="flex justify-center hover:bg-inherit">
          <Link to={nonAdminRole ? ROLE_BASED_URLS[nonAdminRole].dashboard : ADMIN_URLS.payment.list}>
            {isCollapsed ? (
              <img src={smallLogo} alt="logo" className="h-4" />
            ) : (
              <>
                <img src={logoLight} alt="logo" className="block h-6 dark:hidden" />
                <img src={logoDark} alt="logo" className="hidden h-6 dark:block" />
              </>
            )}
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
